import { useState } from "react";
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";
import { formatLocation } from "../utils/locations";
import { ModalShell } from "./ModalShell";

export function PartialModal({ location, onCancel, onSave }) {
  const [partialCount, setPartialCount] = useState(location.partial_count || "");

  return (
    <ModalShell
      icon={<Inventory2OutlinedIcon />}
      title={`Partial count for ${formatLocation(location)}`}
      subtitle={location.item_name}
      onClose={onCancel}
    >
      <div className="modal-field">
        <label htmlFor="partial-count">Partial count</label>
        <input
          id="partial-count"
          type="number"
          min="1"
          max="9"
          value={partialCount}
          onChange={(event) => setPartialCount(event.target.value)}
        />
      </div>
      <div className="modal-actions">
        <button type="button" className="touch-button" onClick={onCancel}>
          Cancel
        </button>
        <button
          type="button"
          className="touch-button"
          onClick={() => {
            const normalized = partialCount === "" ? null : Number(partialCount);
            onSave(normalized);
          }}
        >
          Save
        </button>
      </div>
    </ModalShell>
  );
}
